var voted_users_rtlignore_default = {
  "container": "USO9E",
  "webview": "jqgPJ",
  "avatar_list": "Lc9d9",
  "avatar": "Fm020",
  "user_avatar": "jPgMP",
  "modal": "rCh1m",
  "voted_users_modal": "_8DIQx",
  "overlay": "v1EIy",
  "user_card": "llXon",
  "user_name": "_1W2uw",
  "voted_users_modal_header": "hFJ27",
  "cta": "uCXm1",
  "close_icon": "WfYug",
  "title": "_4IvJw",
  "member_list_container": "unlx0",
  "member_list": "ayzK2",
  "loader": "SQKea",
  "anonymous_counter": "ErLZD",
  "spinner": "oI9iW",
  "spin": "SycOR"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
